export * from "./dynamicTexture.pure";

import "../../Engines/Extensions/engine.dynamicTexture";
